/**
 * Mobile Product Gallery Thumbnail Bar
 * Shows a thumbnail indicator bar at the bottom of product images on mobile
 * Only displays on mobile devices (max-width: 999px)
 */

(function() {
  'use strict';

  const ProductGalleryThumbBar = {
    container: null,
    initialized: false,

    init: function() {
      if (this.initialized) return;
      if (window.innerWidth > 999) return;

      this.createThumbBar();
      this.bindEvents();
      this.initialized = true;
    },

    createThumbBar: function() {
      const gallery = document.querySelector('.product-gallery__carousel');
      if (!gallery) return;

      const mediaItems = gallery.querySelectorAll('.product-gallery__media');
      if (mediaItems.length <= 1) return;

      const thumbBar = document.createElement('div');
      thumbBar.className = 'luxotic-thumb-bar';
      thumbBar.setAttribute('aria-label', 'Image navigation');

      const totalItems = mediaItems.length;
      const screenWidth = window.innerWidth;
      const maxDotWidth = 40;
      const minDotWidth = 20;
      const gap = 8;
      const padding = 20;
      
      const availableWidth = screenWidth - padding;
      let dotWidth = Math.floor(availableWidth / totalItems - gap);
      dotWidth = Math.max(minDotWidth, Math.min(maxDotWidth, dotWidth));

      mediaItems.forEach((item, index) => {
        const dot = document.createElement('span');
        dot.className = 'luxotic-thumb-bar__dot';
        dot.style.width = dotWidth + 'px';
        dot.dataset.index = index;
        if (index === 0) dot.classList.add('active');
        thumbBar.appendChild(dot);
      });

      const existingBar = document.querySelector('.luxotic-thumb-bar');
      if (existingBar) existingBar.remove();

      gallery.parentElement.appendChild(thumbBar);
      this.container = thumbBar;
    },

    bindEvents: function() {
      const gallery = document.querySelector('.product-gallery__carousel');
      if (!gallery) return;

      gallery.addEventListener('scroll', () => {
        this.updateActiveDot();
      });

      let touchStartX = 0;
      gallery.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      gallery.addEventListener('touchend', (e) => {
        const touchEndX = e.changedTouches[0].clientX;
        const diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          setTimeout(() => this.updateActiveDot(), 100);
        }
      }, { passive: true });
    },

    updateActiveDot: function() {
      const gallery = document.querySelector('.product-gallery__carousel');
      const mediaItems = gallery?.querySelectorAll('.product-gallery__media');
      const dots = this.container?.querySelectorAll('.luxotic-thumb-bar__dot');

      if (!gallery || !mediaItems || !dots) return;

      let activeIndex = 0;
      const scrollLeft = gallery.scrollLeft;
      const itemWidth = mediaItems[0]?.offsetWidth || window.innerWidth;

      activeIndex = Math.round(scrollLeft / itemWidth);

      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === activeIndex);
      });
    },

    destroy: function() {
      const thumbBar = document.querySelector('.luxotic-thumb-bar');
      if (thumbBar) thumbBar.remove();
      this.initialized = false;
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    ProductGalleryThumbBar.init();
  });

  document.addEventListener('shopify:section:load', () => {
    ProductGalleryThumbBar.destroy();
    setTimeout(() => ProductGalleryThumbBar.init(), 100);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 999) {
      ProductGalleryThumbBar.destroy();
    } else if (!ProductGalleryThumbBar.initialized) {
      ProductGalleryThumbBar.init();
    }
  });

  window.LuxoticThumbBar = ProductGalleryThumbBar;
})();
